import React from 'react';
import { connect } from 'react-redux';
import MediaQuery from 'react-responsive';
import { withRouter } from 'react-router-dom';

import { STATIC_ROOT } from '../constants';

import SvgComponent from './SvgComponent';

import './ScrollToTopComponent.scss';

/**
 * This component must be include only one time in the application (cf. './App.js')
 * You must nouse it anywhere else
 * This component is used to restore the scroll position when navigating
 */
class ScrollToTopComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            display: this.getOffset() > 300
        };
    }

    componentDidMount() {
        window.addEventListener('scroll', this.toggleDisplay);
    }

    componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
            window.scrollTo(0, 0);
        }
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.toggleDisplay);
    }

    getOffset = () =>
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        (document.documentElement.body && document.documentElement.body.scrollTop) ||
        0;

    toggleDisplay = () => {
        const offset = this.getOffset();
        this.setState({ display: offset > 300 });
    };

    render() {
        const { i18n } = this.props;

        return (
            <MediaQuery query="(max-width: 768px)">
                <a
                    href="#entete"
                    title={i18n.TITLE}
                    className={`retour-haut scroll${this.state.display ? '' : ' hidden'}`}
                    id="retour-haut"
                    onClick={() =>
                        window.scrollTo({
                            top: 0,
                            left: 0,
                            behavior: 'smooth'
                        })
                    }>
                    <SvgComponent
                        src={`${STATIC_ROOT}/fleche.svg`}
                        className="haut"
                        width="12"
                        height="22"
                        aria-hidden="true"
                        focusable="false"
                    />
                    <span className="sr-only">{i18n.TITLE}</span>
                </a>
            </MediaQuery>
        );
    }
}

const mapStateToProps = state => {
    return {
        i18n: state.i18n.feature.SCROLL_TO_TOP
    };
};

export default withRouter(connect(mapStateToProps)(ScrollToTopComponent));



// WEBPACK FOOTER //
// ./src/components/ScrollToTopComponent.js